module.exports = __webpack_public_path__ + "img/MSP-BLog.76763b12.jpg";